/**
 * @module app.query.queryDirective
 */
import appModule from '../module.js';

/**
 * @param {string} appQueryTemplateUrl URL to directive template.
 * @return {angular.Directive} The Directive Definition Object.
 * @ngInject
 */
const exports = function(appQueryTemplateUrl) {
  return {
    restrict: 'E',
    scope: {
      'map': '=appQueryMap',
      'infoOpen': '=appQueryOpen',
      'layersOpen': '=appQueryLayersOpen',
      'mymapsOpen': '=appQueryMymapsOpen',
      'appSelector': '=appQueryAppselector',
      'routingOpen': '=appQueryRoutingOpen',
      'feedbackAnfOpen': '=appQueryFeedbackAnfOpen',
      'language': '=appQueryLanguage',
      'hiddenContent': '=appQueryHiddenInfo',
      'legendsOpen': '=appQueryLegendsOpen'
    },
    controller: 'AppQueryController',
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: appQueryTemplateUrl
  };
};

appModule.directive('appQuery', exports);


export default exports;
